import PropTypes from 'prop-types';
import React from 'react';
import ClassNames from 'classnames';
import D13nStore from 'stores/plugins/d13n';
import moment from 'moment';
import './index.scss';

class BookingReviewLanding extends React.PureComponent {
  static displayName = 'BookingReview-Landing-AnyGuide';

  static propTypes = {
    booking_id: PropTypes.number.isRequired,
    guests: PropTypes.number.isRequired,
    tour_name: PropTypes.string.isRequired,
    guest_firstname: PropTypes.string.isRequired,
    handleDeclineClicked: PropTypes.func.isRequired,
  };

  static defaultProps = {
    theme: 't-Default',
  };

  _rescheduleLocationHref = () => {
    return '/#/bookings/' + this.props.booking_id;
  };

  _handleRescheduleClick = (e) => {
    e.preventDefault();
    window.location.href = this._rescheduleLocationHref();
  };

  render() {
    var containerClasses = ClassNames('LandingContainer', this.props.theme),
      guestsWording =
        this.props.guests > 1 ? D13nStore.d('guests') : D13nStore.d('guest');

    return (
      <div className={containerClasses}>
        <p className="lead">
          We’re sorry you’re not available for the{' '}
          <strong>{this.props.tour_name}</strong> on{' '}
          <strong>{this.props.start_date_formatted}</strong> at{' '}
          <strong>{this.props.start_time_formatted}</strong> for{' '}
          {this.props.guests} {guestsWording}.
        </p>
        <p>
          Would you like to propose another time to {this.props.guest_firstname}
          ?
        </p>
        <p>
          <a onClick={this._handleRescheduleClick} className="btn">
            Reschedule in Dashboard
          </a>
        </p>
        <p>or</p>
        <p>
          <a onClick={this.props.handleDeclineClicked} className="btn green">
            Decline Booking
          </a>
        </p>
      </div>
    );
  }
}

export default BookingReviewLanding;
